import React from 'react';
import {
  useMantineTheme,
  createStyles,
} from '@mantine/core';
import Link from './Link';

const useStyles = createStyles((theme) => {

  const getShadow = (alpha) => {
    const color = theme.colors.violet[9];
    const alphaColor = theme.fn.rgba(color, alpha);
    return `drop-shadow( 0px 4px 8px ${alphaColor})`
  };
  const transition = `200ms ${theme.transitionTimingFunction} all`;
  const transformOrigin = 'center';

  return {
  twizLogo: {
    transition,
    transformOrigin,
    filter: getShadow(0.2),
    '&:hover': {
      filter: getShadow(0.3),
      transform: 'scale(1.1) !important',
      '#grid': {  
        opacity: 1,
        transform: 'rotate(8deg)',
      },
      '#icon': {
        transform: 'rotate(-4deg)',
      }
    },
    '&:active': {
      transform: 'scale(0.9) !important',
    },
    '#grid': {
      transition,
      transformOrigin,
      opacity: 0.7,
    },
    '#icon': {
      transition, 
      transformOrigin,
    }
  }
}});

function TwizLogo(props){

  const { classes } = useStyles();
  const { colors: { violet } } = useMantineTheme();
  
  const {
    width = 48,
    height = 48,
    gridColor = 'white',
    cardColor = 'white',
    iconColor = violet[6],
    style,
  } = props;

  return (
    <Link href='/'>
      <svg
        id='twiz-logo'
        style={style}
        className={classes.twizLogo}
        width={width}
        height={height}
        viewBox='0 0 48 48'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path id='grid' d='M40.046 16.0226L38.747 6.78008C38.5933 5.68626 37.582 4.92417 36.4881 5.07789L32.7933 5.59717L27.2376 6.37797M40.046 16.0226L41.6221 27.2376M40.046 16.0226L6.37686 20.7545M41.6221 27.2376L42.9222 36.4881C43.0759 37.5819 42.3138 38.5933 41.22 38.747L31.9695 40.0471M41.6221 27.2376L7.95302 31.9695M6.37686 20.7545L5.07791 11.512C4.92418 10.4181 5.68628 9.40681 6.7801 9.25309L16.0226 7.95414M6.37686 20.7545L7.95302 31.9695M7.95302 31.9695L9.2531 41.22C9.40683 42.3138 10.4182 43.0759 11.512 42.9222L20.7545 41.6233M16.0226 7.95414L27.2376 6.37797M16.0226 7.95414L20.7545 41.6233M27.2376 6.37797L31.9695 40.0471M31.9695 40.0471L20.7545 41.6233' stroke={gridColor} strokeWidth='1.5'/>
        <rect id='card' x='11' y='11' width='26' height='26' rx='2' fill={cardColor} />
        <path id='icon' d='M29.0399 22.5189C29.2887 23.0219 30.0541 22.8254 29.997 22.2674C29.7454 19.7317 27.0008 19.1979 24.6541 16.3873V15.778C24.6541 15.3489 24.3089 15 23.8843 15C23.4597 15 23.1145 15.3489 23.1145 15.778V27.7456C22.5981 27.4616 21.9844 27.2958 21.327 27.2958C19.4886 27.2958 18 28.5722 18 30.1479C18 31.7236 19.4887 33 21.327 33C23.1653 33 24.654 31.7236 24.654 30.1479L24.6531 19.3593C26.562 19.8298 28.147 20.7206 29.0399 22.5189Z' fill={iconColor} />
      </svg>
    </Link>
  )


};

export default TwizLogo;